import getAppliedValues
  from '../flex-facets-adapter/adapt-function/adapt-generic/get-applied-values';

const parseHtmlEntities = plainText => {
  if (typeof DOMParser === 'undefined') {
    return plainText;
  }

  const doc = new DOMParser().parseFromString(plainText, 'text/html');

  return doc.documentElement.textContent;
};

export const allOptionsIsInactive = options => options?.every(
  option =>  option?.isActive === 'false'
);

const outInvalidOptions = option => !!option.searchFacetOptionName &&
  !!option.searchFacetOptionValue;

const optionIsInvalid = option => !option.name || !option.value;

const adaptOptions = facetOptionList => (
  facetOptionList
    .filter(outInvalidOptions)
    .map(facet => ({
      isActive: facet.isActive,
      id: facet.searchFacetOptionId,
      value: parseHtmlEntities(facet.searchFacetOptionName),
      name: parseHtmlEntities(facet.searchFacetOptionValue),
      applied: facet.isSelected === 'true',
      tagDisplayLabel: parseHtmlEntities(facet.searchFacetOptionValue),
    }))
);

const adaptGenericFacet = facet => {
  const options = adaptOptions(
    facet.searchFacetOptionGroupList.searchFacetOptionList,
  );

  const everyOptionIsInvalid = options.every(optionIsInvalid);

  return {
    facet: everyOptionIsInvalid ? undefined : {
      name: facet.searchFacetId,
      type: 'simple',
      options,
    },
    appliedValues: everyOptionIsInvalid ? [] : getAppliedValues(options),
  };
};

export default adaptGenericFacet;
